import request from '@/utils/request';

// 七牛上传文件获取token
const getToken = () => {
  return request({
    method: 'GET',
    url: '/files/upload_token/',
  });
};

export default {
  getToken,
};
